import { useMutation } from 'glimmer-apollo'
import { parse } from 'graphql'

type SetupMultiPaymentMethodsInput = {
  input: {
    quoteId: string
    customer: {
      name: string
      email: string
      phone: string
    }
    idempotencyKey?: string
  }
}

type SetupMultiPaymentMethodsResponse = {
  setupMultiPaymentMethods: {
    __typename?: string
    clientSecret?: string
    message?: string
  }
}

export function setupMultiPaymentMethods(
  context: Object,
  variables: SetupMultiPaymentMethodsInput
): Promise<SetupMultiPaymentMethodsResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const setupMultiPaymentMethodsMutation = useMutation<SetupMultiPaymentMethodsResponse, SetupMultiPaymentMethodsInput>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(new Error('Failed to setup multi payment methods.', { cause: error }))
        },
        onComplete: (data: SetupMultiPaymentMethodsResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    setupMultiPaymentMethodsMutation.mutate(variables)
  })
}

const mutation = parse(`
  mutation SetupMultiPaymentMethods($input: SetupMultiPaymentMethodsInput!) {
    setupMultiPaymentMethods(input: $input) {
      ... on SetupMultiPaymentMethodsSuccess {
        clientSecret
      }

      ... on GenericError {
        message
      }
    }
  }
`)

export default mutation
